import { createFileRoute } from "@tanstack/react-router";
import { SeoPage } from "@/components/SeoPage";
import { faqJsonLd } from "@/lib/seo-jsonld";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN, SOURCE_PROP_2025_26, LAST_REVIEWED } from "@/lib/official-sources";

const faqs = [
  { q: "Kan ett café få serveringstillstånd?", a: "Ja. Från 1 juni 2026 är kraven på eget kök och varierat utbud av lagad mat slopade. Matservering är inte längre ett villkor för tillståndet. Caféer som främst serverar bakverk och smörgåsar kan därför få serveringstillstånd om övriga krav uppfylls." },
  { q: "Räcker det att servera smörgåsar och bakverk?", a: "Ja – och det krävs egentligen inte ens det. Efter lagändringen 1 juni 2026 får kommunen inte ställa något krav på matutbud vid prövningen. Vad ni serverar är ett affärsbeslut." },
  { q: "Krävs kunskapsprov?", a: "Ja, samma kunskapsprov i alkohollagen gäller för café som för restaurang." },
];

export const Route = createFileRoute("/serveringstillstand-cafe")({
  component: () => (
    <SeoPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Guider", to: "/serveringstillstand-och-kunskapsprov" },
        { label: "För café" },
      ]}
      title="Serveringstillstånd för café"
      intro="Vill du servera öl och vin på caféet? Här är kraven på lokal, mat och kunskapsprov för att få serveringstillstånd – uppdaterat för de nya reglerna 2026."
      lastReviewed={LAST_REVIEWED}
      sources={[SOURCE_FOHM_VAGLEDNING, SOURCE_ALKOHOLLAGEN, SOURCE_PROP_2025_26]}
      sections={[
        { h2: "Kraven för café (nya regler 2026)", body: "Från 1 juni 2026 är kraven på eget kök och varierat utbud av lagad mat borttagna. Matservering är inte längre ett villkor för tillståndet. Caféer som främst serverar bakverk eller smörgåsar kan därför få serveringstillstånd om övriga krav (lämplighet, lokal, kunskapsprov, ordning) uppfylls." },
        { h2: "Folköl utan tillstånd", body: "Servering av folköl (max 3,5 %) kräver inte serveringstillstånd, men ska anmälas till kommunen och uppfyller egna mat- och lokalkrav." },
        { h2: "Lokal, ordning och kassa", body: "Lokalen ska vara godkänd ur brand- och ordningssynpunkt. Tydlig prislista, kassaregister och rutin för ålderskontroll krävs." },
        { h2: "Kunskapsprovet", body: "PBI måste klara kommunens kunskapsprov. Träna fritt i Alkoholprovet inför skarpa provet." },
      ]}
      faqs={faqs}
      related={{
        title: "Relaterade sidor",
        links: [
          { to: "/serveringstillstand-och-kunskapsprov", label: "Hub – alla guider" },
          { to: "/nya-regler-serveringstillstand-2026", label: "Nya regler 2026" },
          { to: "/serveringstillstand-restaurang", label: "För restaurang" },
          { to: "/serveringstillstand-bar", label: "För bar & nattklubb" },
          { to: "/serveringstillstand-catering", label: "För catering" },
          { to: "/serveringstillstand-stockholm", label: "Serveringstillstånd Stockholm" },
          { to: "/serveringstillstand-goteborg", label: "Serveringstillstånd Göteborg" },
          { to: "/serveringstillstand-malmo", label: "Serveringstillstånd Malmö" },
          { to: "/kunskapsprov-alkohollagen", label: "Kunskapsprov i alkohollagen" },
        ],
      }}
    />
  ),
  head: () => ({
    meta: [
      { title: "Serveringstillstånd för café – krav & ansökan" },
      { name: "description", content: "Serveringstillstånd för café: nya regler 2026 (köks- och matkrav slopas), lokal och kunskapsprov i alkohollagen." },
      { property: "og:title", content: "Serveringstillstånd för café" },
      { property: "og:description", content: "Krav och ansökan för café." },
      { property: "og:url", content: "https://alkoholprovet.se/serveringstillstand-cafe" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/serveringstillstand-cafe" }],
    scripts: [
      faqJsonLd(faqs),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Guider", url: "https://alkoholprovet.se/serveringstillstand-och-kunskapsprov" },
        { label: "För café", url: "https://alkoholprovet.se/serveringstillstand-cafe" },
      ]),
    ],
  }),
});
